import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    searchKeyword: "",
    jobType: "",
    salaryType: ""
};

export const filterSlice = createSlice({
    name: 'filter',
    initialState,
    reducers: {
        searchByKeyword: (state, action) => {
            state.searchKeyword = action.payload
        },
        filterByType: (state, action) => {
            state.jobType = action.payload
        },
        filterBySalary: (state, action) => {
            state.salaryType = action.payload
        }
    },

});

export const { searchByKeyword, filterByType, filterBySalary } = filterSlice.actions;
export default filterSlice.reducer;
